import { html } from 'lit';
const ToggleUp =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' d="M11.85 8.868a.757.757 0 0 1 1.3 0l3.248 5.527c.29.491-.072 1.105-.65 1.105H9.252c-.577 0-.938-.614-.65-1.105z"/>
  </svg>
`;
export default ToggleUp;
